import {Layout} from '@ui-kitten/components';
import React, {useEffect} from 'react';
import {Alert, StyleSheet} from 'react-native';
import {useSelector} from 'react-redux';
import {postCreateIosPayment} from '../../apis';
import {DRAWER_ROUTES} from '../../navigation/constants';
import {getSubjectNameById, px, useAsyncFn, useIsLandscape} from '../../utils';
import {renderIf} from '../../utils/Utils';
import {LoadingButton} from '../components';
import {PaymentErrorModal} from './PaymentErrorModal';

import {
  initConnection,
  clearTransactionIOS,
  requestPurchase,
  useIAP,
  finishTransaction,
} from 'react-native-iap';
import {withIAPContext} from 'react-native-iap';

const InAppPayment = ({
  navigation,
  kidId,
  packageId,
  selectedTimeTable,
  subjectNames,
  renewData,
  iosProductId,
  numberOfSubjects,
  monthNumber,
  isRenew,
  handleClosePaymentModal,
}) => {
  // console.log('iosProductId', iosProductId);
  // console.log('numberOfSubjects', numberOfSubjects);

  //setup({storekitMode: 'STOREKIT1_MODE'});

  var isPaymentError = false;
  const isLandscape = useIsLandscape();
  const subjects = useSelector((state) => state.general.subjects);
  const [isProcessing, setIsProcessing] = React.useState(false);

  const {currentPurchase, getProducts} = useIAP();

  if (!isRenew) {
    if (
      selectedTimeTable &&
      selectedTimeTable.length > 0 &&
      selectedTimeTable[0].scheduleId
    ) {
      //console.log('Process to payment');
    } else {
      isPaymentError = true;
    }
  }

  const [{}, handlePurchase] = useAsyncFn(
    async (receipt) => {
      if (!selectedTimeTable?.[0]?.scheduleId) {
        Alert.alert('Your payment session is expired, please try again!');
        if (isLandscape) {
          handleClosePaymentModal();
        }
        navigation.navigate(DRAWER_ROUTES.home.path);
        return;
      }

      try {
        const subjectNamesData = subjectNames
          ? subjectNames.replace(/ /g, '')
          : selectedTimeTable
              ?.map(({subjectId}) =>
                getSubjectNameById({id: subjectId, subjects}),
              )
              .join(',');

        const response = await postCreateIosPayment({
          kidId,
          receipt,
          packageId,
          selectedTimeTable,
          subjectNames: subjectNamesData,
          renewData,
          monthNumber,
        });
        const {status, message} = response || {};
        const alertTitle = status === true ? 'Success' : 'Error';
        Alert.alert(alertTitle, message, [
          {
            text: 'OK',
            onPress: () => {
              if (isLandscape) {
                handleClosePaymentModal();
              }
              navigation.navigate(DRAWER_ROUTES.home.path);
            },
          },
        ]);
      } catch (error) {
        Alert.alert(String(error));
        if (isLandscape) {
          handleClosePaymentModal();
        }
        navigation.navigate(DRAWER_ROUTES.home.path);
      }
    },
    [kidId, packageId, selectedTimeTable, subjectNames, renewData],
  );

  const processPayment = async () => {
    try {
      if (!iosProductId) {
        isPaymentError = true;
        return;
      }
      var quantity = 1;
      if (iosProductId.includes('individual')) {
        quantity = numberOfSubjects;
      }
      setIsProcessing(true);
      const iosSku = iosProductId?.trim();
      // console.log('iosSku', iosSku);
      // console.log('quantity', quantity);

      await getProducts({skus: [iosSku]});
      // console.log('products', products);
      const purchaseResult = await requestPurchase({
        sku: iosSku,
        quantity,
        andDangerouslyFinishTransactionAutomaticallyIOS: false,
      });
      //console.log(purchaseResult);
      const {transactionId, transactionReceipt} = purchaseResult || {};
      if (transactionId) {
        //handlePurchase();
        //const purchaseObj = JSON.parse(purchaseResult?.jsonRepresentation);
        const txnResult = await finishTransaction({
          purchase: purchaseResult,
          isConsumable: true,
        });
        console.log('txnResult', txnResult);

        // const transactionReceipt = await getReceiptIOS({forceRefresh: true});
        //console.log('transactionReceipt', transactionReceipt);
        // const receiptBody = {
        //   'receipt-data': transactionReceipt,
        //   password: 'f66e0ca9a6764fa19e0ddd32e370cefb',
        // };
        await handlePurchase(transactionReceipt);
        // console.log('receiptBody', receiptBody);
        // const appleResponse = await validateReceiptIos(receiptBody, true);
        // console.log('appleResponse', appleResponse);
        // const {status} = appleResponse || {};
        // console.log('status:>', status);
      } else {
        Alert.alert('Something went wrong, please try again!');
      }
    } catch (err) {
      console.warn('Error:>', err);
      Alert.alert(err.message);
    } finally {
      setIsProcessing(false);
    }
  };

  useEffect(() => {
    //console.log('currentPurchase', currentPurchase);
  }, [currentPurchase]);

  useEffect(() => {
    initConnection()
      .then(() => {
        console.log('connected');
        clearTransactionIOS();
      })
      .catch((err) => {
        console.log('err', err);
      });
  }, []);

  return (
    <Layout>
      {renderIf(isPaymentError, <PaymentErrorModal />)}
      <LoadingButton
        loading={isProcessing}
        style={styles.button}
        onPress={processPayment}>
        {'Pay now'}
      </LoadingButton>
    </Layout>
  );
};

const styles = StyleSheet.create({
  rowContainer: {
    flexDirection: 'row',
    width: '100%',
  },
  rowInput: {
    width: '50%',
  },
  button: {
    marginTop: 60,
    marginHorizontal: px(57),
  },
});

export default withIAPContext(InAppPayment);
